// MiniPopUp.jsx
import React, { useRef } from "react";
import { SlPrinter } from "react-icons/sl";
import { MdAttachFile } from "react-icons/md";

const MiniPopUp = ({ onPrint, attach, setShowPopUp, showPopUp, uploading }) => {
  const fileRef = useRef(null);
  if (!showPopUp) return null;

  const openPicker = (e) => {
    e.preventDefault();
    e.stopPropagation();
    fileRef.current?.click();
  };

  const onFilesPicked = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length) attach(files);
    e.target.value = "";         // allow re-selecting same file later
    setShowPopUp(false);
  };

  const doPrint = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onPrint ? onPrint() : window.print();
    setShowPopUp(false);
  };

  return (
    <div
      id="MiniPopUp"
      className="border flex flex-col w-[160px] shadow-md rounded absolute top-[-40px] bg-white right-[130px] z-20 print:hidden"
      onClick={(e) => e.stopPropagation()} // don't bubble to the page wrapper
    >
      <button
        type="button"                 // <-- important
        onClick={doPrint}
        className="px-3 py-2.5 flex flex-row items-center hover:bg-gray-50"
      >
        <SlPrinter />
        <span className="pl-3">Print</span>
      </button>

      <hr />

      <button
        type="button"                 // <-- important
        onClick={openPicker}
        disabled={uploading}
        className="px-3 py-2.5 flex flex-row items-center hover:bg-gray-50 disabled:opacity-60"
        aria-busy={uploading ? "true" : "false"}
      >
        <MdAttachFile size={20} />
        <span className="pl-2">{uploading ? "Uploading..." : "Attach"}</span>
      </button>

      <input
        ref={fileRef}
        type="file"
        multiple
        accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt"
        className="hidden"
        onChange={onFilesPicked}
      />
    </div>
  );
};

export default MiniPopUp;
